module.exports = __webpack_public_path__ + "img/sidebar-4.f34e943f.jpg";